import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "/api",
  withCredentials: true,
});

let csrfToken = null;

export const setCsrfToken = (token) => {
  csrfToken = token;
};

apiClient.interceptors.request.use((config) => {
  if (csrfToken && ["post", "put", "patch", "delete"].includes((config.method || "").toLowerCase())) {
    config.headers["X-CSRF-Token"] = csrfToken;
  }
  return config;
});

export default apiClient;
